import { render, staticRenderFns } from "./Talent-list.vue?vue&type=template&id=60b68083&scoped=true&"
import script from "./Talent-list.vue?vue&type=script&lang=js&"
export * from "./Talent-list.vue?vue&type=script&lang=js&"
import style0 from "./Talent-list.vue?vue&type=style&index=0&id=60b68083&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b68083",
  null
  
)

export default component.exports